import styled from "styled-components"

import P from "../../elements/p"

const SpecialText = styled(P)`
  font-size: 13px;
  text-align: left;
  margin: 0;
  margin-left: 8px;
  color: #67c462;
  height: 17px;
`
export default SpecialText
